import { ReactNode } from 'react';
import { atom } from 'recoil';

export const notesPanelOpenState = atom({
  key: 'NOTE_PANEL',
  default: false
});

export const documentActionPanelOpenState = atom({
  key: 'DOC_ACTION_PANEL',
  default: false
});

export const modalOpenState = atom({
  key: 'MODAL_OPEN',
  default: false
});

export const modalContentState = atom({
  key: 'MODAL_CONTETNT',
  default: <div/>
});
